var _a;
/**
 * @internal
 */
import React, { createContext, useContext, useState } from 'react';
import useIsomorphicLayoutEffect from '@polestar/component-warehouse-react/hooks/useIsomorphicLayoutEffect';
import { UIDReset, useUID } from 'react-uid';
export const SSRContext = createContext({
    isSSR: !(typeof process === 'object' && ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.JEST_WORKER_ID)),
});
export const useSSR = () => useContext(SSRContext);
/**
 * The SSRContext makes sure the server-side ids and client-side ids are the same.
 */
const SSRProvider = ({ children }) => {
    const [isSSR, setIsSSR] = useState(true);
    useIsomorphicLayoutEffect(() => {
        setIsSSR(false);
    }, []);
    return (React.createElement(UIDReset, null,
        React.createElement(SSRContext.Provider, { value: { isSSR } }, children)));
};
export default SSRProvider;
/**
 * React < 18, use `react-uid` `useUID` hook
 **/
const useCounterUseUID = () => useUID();
/**
 * React >= 18, use `react` built-in `useId` hook
 *
 * (use this React?.useId notation to keep supporting React v17 Polestar boilerplate without issues)
 **/
const useCounterUseId = () => { var _a; return (_a = React === null || React === void 0 ? void 0 : React.useId) === null || _a === void 0 ? void 0 : _a.call(React); };
/**
 * Todo: Completely replace this with `useId` if we fully move over to React v18
 */
export function useSSRSafeId(prefix = '', id) {
    /**
     * To work around react's conditional hook rule, we assign the correct id generator hook to a new hook based upon
     * the react version.
     **/
    const reactVersion = Number(React.version.split('.')[0]);
    const useCounter = reactVersion >= 18 ? useCounterUseId : useCounterUseUID;
    const counter = useCounter();
    return id || `${prefix || 'cw'}-${counter}`;
}
export const useIsSSR = () => {
    return useContext(SSRContext).isSSR;
};
